export default __webpack_public_path__ + "static/filter-button-anatomy-light-c0ce8ecd5904f1e36ff95f03a298ae7e.png";